import { render, staticRenderFns } from "./MzStar2.vue?vue&type=template&id=a81dbaf2&"
import script from "./MzStar2.vue?vue&type=script&lang=js&"
export * from "./MzStar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports